import React, { useEffect, useState, useContext, useRef } from "react";
import Loader from "react-loader-spinner";
import {
  Button,
  Card,
  Table,
  Container,
  Row,
  Col,
  Form,
} from "react-bootstrap";
import Modal from "react-modal";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import Axios from "../utils/axios";
import { Link, useLocation } from "react-router-dom";
import { getCategories } from "services/ourProducts";
import { Helper } from "../helper";
import CustomStyle from "../styles";
import { AuthContext } from "../context/auth";
import { showToast } from "utils/general";
import { getWarehouses } from "services/warehouseApis";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "600px",
    width: "95%",
    maxHeight: "90vh",
    padding: "30px",
    borderRadius: "15px",
    border: "none",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: 1000,
  },
};

Modal.setAppElement("#root");

function Promos() {
  const [loading, setLoading] = useState(false);
  const [loadingPromos, setLoadingPromos] = useState(false);
  const [loadingPromoDelete, setLoadingPromoDelete] = useState(null);
  const [activePromo, setActivePromo] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editImagePreview, setEditImagePreview] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [promos, setPromos] = useState({});
  const [results, setResults] = useState([]);
  const [limit] = useState(10);
  const [processedWarehouses, setProcessedWarehouses] = useState([]);
  const context = useContext(AuthContext);
  const [datas, setDatas] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [validated, setValidated] = useState(false);
  const [currentWarehouse, setCurrentWarehouse] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [formValidated, setFormValidated] = useState(false);
  const [id, setId] = useState(0);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [mediaUrlType, setMediaUrlType] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);

  const [offer, setOffer] = useState("");
  const [offerType, setOfferType] = useState("");
  const [fundingSource, setFundingSource] = useState("");
  const [status, setStatus] = useState("");
  const [promoType, setPromoType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);

  const location = useLocation();

  let titleInput = useRef(null);
  let offerInput = useRef(null);
  let offerTypeInput = useRef(null);
  let descriptionInput = useRef(null);
  let mediaInput = useRef(null);

  let editMediaInput = useRef(null);

  useEffect(() => {
    fetchData();
    fetchPromos();
    fetchAvailableCategories();
  }, []);

  const fetchAvailableCategories = async () => {
    const { token } = context.authState;
    await getCategories(token, (res) => {
      if (res.status) {
        const mappedCategories = res.data.map((cate) => ({
          label: cate.Description,
          value: cate.DeptID,
        }));
        setAvailableCategories(mappedCategories);
      }
    });
  };

  useEffect(() => {
    if (activePromo?._id) {
      setId(activePromo?._id || 0);
      setTitle(activePromo?.title || "");
      setOffer(activePromo?.offer || "");
      setOfferType(activePromo?.offerType || "");
      setBody(activePromo?.description || "");
      setFundingSource(activePromo?.fundingSource || "");
      setStatus(activePromo?.status || "");
      setPromoType(activePromo?.type || "discount");
      setStartDate(
        activePromo?.startDate
          ? new Date(activePromo.startDate).toISOString().slice(0, 16)
          : "",
      );
      setEndDate(
        activePromo?.endDate
          ? new Date(activePromo.endDate).toISOString().slice(0, 16)
          : "",
      );
      setPaymentOptions(activePromo?.paymentOptions || []);
      setSelectedCategories(
        activePromo?.categories
          ?.map((c) => availableCategories.find((ac) => ac.value === c))
          .filter(Boolean) || [],
      );
      setMediaUrl(activePromo?.media || "");
      setMediaUrlType(activePromo?.mediaType || "");
      setFormValidated(false);
    } else {
      setId(0);
      setTitle("");
      setOffer("");
      setOfferType("");
      setBody("");
      setFundingSource("");
      setStatus("");
      setPromoType("discount");
      setStartDate("");
      setEndDate("");
      setPaymentOptions([]);
      setSelectedCategories([]);
      setMediaUrl("");
      setMediaUrlType("");
      setFormValidated(false);
    }
  }, [promos, activePromo]);

  const fetchData = async () => {
    const { token } = context.authState;
    setLoading(true);
    try {
      let processedWarehousesResponse = await getWarehouses(token);

      if (processedWarehousesResponse?.data) {
        setProcessedWarehouses(processedWarehousesResponse?.data || []);
      }
      setLoading(false);
    } catch (error) {
      console.error("fetchData error:", error);
      showToast("Oops. failed to fetch warehouses");
      setLoading(false);
    }
  };

  const fetchPromos = async (offSet = 1) => {
    const { token } = context.authState;
    setLoadingPromos(true);
    try {
      let promosResponse = await Helper.getData(
        `${process.env.REACT_APP_API_V2}/admin/promos?limit=${limit}&page=${offSet}`,
        token,
      );

      if (promosResponse?.data) {
        setPromos(promosResponse?.data || []);
        setResults(promosResponse?.data?.results || []);
      }
      setLoadingPromos(false);
    } catch (error) {
      console.error("fetchPromos error:", error);
      showToast("Oops. failed to fetch promos");
      setLoadingPromos(false);
    }
  };

  const handleDeleteSubmit = async (item) => {
    setLoadingPromoDelete(item?._id);
    try {
      const { token } = context.authState;
      let response = await Axios.delete(
        `${process.env.REACT_APP_API_V2}/admin/promos/${item?._id}`,
        {
          headers: {
            "x-access-token": token,
          },
        },
      );

      const { status } = response?.data || {};

      if (status && status == "success") {
        showToast("Promo Deleted", "success");
        let array = [...results]; // make a separate copy of the array
        const index = results ? results?.indexOf(item) : -1;
        if (index !== -1) {
          array.splice(index, 1);
          setResults(array);
        }
      } else {
        showToast("Oops. Failed to delete promo");
      }
      setLoadingPromoDelete(null);
    } catch (error) {
      console.error("handleDeleteSubmit error:", error);
      showToast("Oops. something went wrong while deleting promo");
      setLoadingPromoDelete(null);
    }
  };

  const handlePageClick = (data) => {
    let selected = data.selected + 1;

    fetchPromos(selected);
  };

  const fetchWarehousePromos = async (id) => {
    setFetchLoading(true);
    setCurrentWarehouse(id);
    setSelectedWarehouse([id]);
    try {
      let response = await Helper.getData(
        `${process.env.REACT_APP_API_V2}/admin/promos/warehouse/${id}`,
      );

      setDatas(response?.data?.results || []);
    } catch (error) {
      console.error("fetchWarehousePromos error:", error);
      showToast("Oops. failed to fetch warehouse promos");
    }
    setFetchLoading(false);
  };

  const handleCheckbox = (item) => {
    if (selectedWarehouse.includes(item._id)) {
      let newWH = selectedWarehouse.filter((wid) => wid != item._id);
      setSelectedWarehouse(newWH);
    } else {
      setSelectedWarehouse([...selectedWarehouse, item._id]);
    }
  };

  const handleImageChange = (e, target = "add") => {
    if (e.target.files?.[0]) {
      let reader = new FileReader();
      reader.onload = (event) => {
        if (target === "add") {
          setImagePreview(event.target.result);
        } else {
          setEditImagePreview(event.target.result);
        }
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onFormSubmit = async (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
    } else {
      const formData = new FormData();
      formData.append("title", titleInput.current.value);
      formData.append("description", descriptionInput.current.value);
      formData.append("offer", Number.parseInt(offerInput.current.value, 10));
      formData.append("offerType", offerTypeInput.current.value);
      formData.append("fundingSource", fundingSource);
      formData.append("status", status);
      formData.append("type", promoType);
      if (startDate)
        formData.append("startDate", new Date(startDate).toISOString());
      if (endDate) formData.append("endDate", new Date(endDate).toISOString());

      paymentOptions.forEach((opt) => formData.append("paymentOptions[]", opt));
      selectedCategories.forEach((cat) =>
        formData.append("categories[]", cat.value),
      );
      selectedWarehouse.forEach((wh) => formData.append("warehouses[]", wh));

      if (mediaInput.current.files[0]) {
        formData.append("media", mediaInput.current.files[0]);
      }
      setSubmitLoading(true);

      try {
        const { token } = context.authState;
        await Axios.post(
          `${process.env.REACT_APP_API_V2}/admin/promos`,
          formData,
          {
            headers: {
              "x-access-token": token,
            },
          },
        );

        fetchData();
        fetchPromos();
        !!currentWarehouse && fetchWarehousePromos(currentWarehouse);
        setIsOpen(false);
      } catch (error) {
        console.error("onFormSubmit error:", error);
        showToast(JSON.stringify(error.response.data.message));
      }

      setSubmitLoading(false);
    }
  };

  const handleUpdateSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setFormValidated(false);
    } else {
      setEditLoading(true);

      const formData = new FormData();
      formData.append("id", id);
      formData.append("title", title);
      formData.append("description", body);
      formData.append("offer", Number.parseInt(offer, 10));
      formData.append("offerType", offerType);
      formData.append("fundingSource", fundingSource);
      formData.append("status", status);
      formData.append("type", promoType);
      if (startDate)
        formData.append("startDate", new Date(startDate).toISOString());
      if (endDate) formData.append("endDate", new Date(endDate).toISOString());

      paymentOptions.forEach((opt) => formData.append("paymentOptions[]", opt));
      selectedCategories.forEach((cat) =>
        formData.append("categories[]", cat.value),
      );
      selectedWarehouse.forEach((wh) => formData.append("warehouses[]", wh));

      if (editMediaInput.current?.files[0]) {
        formData.append("media", editMediaInput.current.files[0]);
      } else if (mediaUrl) {
        formData.append("media", mediaUrl);
        formData.append("mediaType", mediaUrlType);
      }

      try {
        const { token } = context.authState;
        await Axios.patch(
          `${process.env.REACT_APP_API_V2}/admin/promos/${activePromo?._id}`,
          formData,
          {
            headers: {
              "x-access-token": token,
            },
          },
        );

        showToast("Promo Updated", "success");
        fetchData();
        fetchPromos();
        !!currentWarehouse && fetchWarehousePromos(currentWarehouse);
        setActivePromo(null);
        setCurrentWarehouse("");
        setEditLoading(false);
      } catch (error) {
        console.error("handleUpdateSubmit error:", error);
        showToast("Oops. something went wrong while saving item");
        setEditLoading(false);
      }
    }

    setFormValidated(true);
  };

  if (
    Helper.isFinance(context.authState?.admin) ||
    // Helper.isPopulator(context.authState?.admin) ||
    Helper.isAdministrator(context.authState?.admin)
  ) {
    return (
      <div style={{ textAlign: "center" }}>
        <small>You are not permitted to view this page</small>
      </div>
    );
  }

  if (loading) {
    return (
      <div
        style={{
          flex: 1,
          textAlign: "center",
          padding: "20px 0px",
        }}
      >
        <Loader
          type="Oval"
          color={CustomStyle.colors.primary}
          height={50}
          width={50}
        />
      </div>
    );
  }

  return (
    <>
      <Container fluid id="MainArea">
        <Row>
          {currentWarehouse ? (
            <Col md="8">
              <div style={{ marginBottom: "10px" }}>
                <Button
                  className="btn-fill form-control"
                  type="submit"
                  variant="primary"
                  style={{
                    background: CustomStyle.colors.primary,
                    borderColor: CustomStyle.colors.primary,
                  }}
                  onClick={() => setCurrentWarehouse("")}
                >
                  All Promos
                </Button>
              </div>
              {fetchLoading ? (
                <div
                  style={{
                    flex: 1,
                    textAlign: "center",
                    padding: "20px 0px",
                    display: "flex",
                    alignItems: "center",
                    height: "80px",
                    justifyContent: "center",
                  }}
                >
                  <Loader
                    type="Oval"
                    color={CustomStyle.colors.primary}
                    height={50}
                    width={50}
                  />
                </div>
              ) : (
                <Card className="card-tasks">
                  <Card.Header
                    style={{ display: "flex" }}
                    className="justify-content-md-between"
                  >
                    <Card.Title as={Col} flex="1">
                      Warehouse{" "}
                      {processedWarehouses.find(
                        (itm) => itm._id == currentWarehouse,
                      )?.name || ""}{" "}
                      Promos
                    </Card.Title>
                    <Card.Title as={Col} md="3">
                      <Button
                        className="btn-fill form-control"
                        type="submit"
                        variant="primary"
                        style={{
                          background: CustomStyle.colors.primary,
                          borderColor: CustomStyle.colors.primary,
                        }}
                        onClick={() => setIsOpen(true)}
                      >
                        Add Promo
                      </Button>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <div className="table-full-width" style={{ overflowX: "auto" }}>
                      <Table className="table-hover table-striped" style={{ minWidth: "500px" }}>
                        <thead>
                          <tr>
                            <th className="border-0">Title</th>
                            <th className="border-0">Body</th>
                            <th className="border-0">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {datas.length > 0 ? (
                            datas.map((item, index) => (
                              <tr key={item._id}>
                                <td>
                                  <div style={{ display: "flex" }}>
                                    <img
                                      style={{ width: "80px" }}
                                      alt=""
                                      className="img-fluid rounded mr-2"
                                      src={item?.media}
                                    />
                                    {item.title}
                                  </div>
                                </td>
                                <td>{item.description}</td>
                                <td>
                                  <Button
                                    as={Link}
                                    to={`${location.pathname}/${item._id}`}
                                    className="btn-fill form-control mb-2"
                                    type="submit"
                                    variant="primary"
                                    style={{
                                      background: CustomStyle.colors.primary,
                                      borderColor: CustomStyle.colors.primary,
                                    }}
                                  >
                                    View
                                  </Button>
                                  <Button
                                    className="btn-fill form-control mb-2"
                                    type="submit"
                                    variant="info"
                                    style={{
                                      background: CustomStyle.colors.info,
                                      borderColor: CustomStyle.colors.info,
                                    }}
                                    onClick={() => setActivePromo(item)}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    className="btn-fill form-control"
                                    type="submit"
                                    variant="danger"
                                    style={{
                                      background: CustomStyle.colors.danger,
                                      borderColor: CustomStyle.colors.danger,
                                    }}
                                    onClick={() => {
                                      if (
                                        globalThis.confirm(
                                          "Are you sure you want to delete promo?",
                                        )
                                      ) {
                                        handleDeleteSubmit(item);
                                      }
                                    }}
                                  >
                                    {loadingPromoDelete == item?._id ? (
                                      <Loader
                                        type="Oval"
                                        color={CustomStyle.colors.white}
                                        height={20}
                                        width={20}
                                      />
                                    ) : (
                                      "Delete"
                                    )}
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="2"
                                style={{
                                  textAlign: "center",
                                  color: CustomStyle.colors.danger,
                                }}
                              >
                                <small>No promo found</small>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Card.Body>
                </Card>
              )}
            </Col>
          ) : (
            <Col md="8">
              {loadingPromos ? (
                <div
                  style={{
                    flex: 1,
                    textAlign: "center",
                    padding: "20px 0px",
                    display: "flex",
                    alignItems: "center",
                    height: "80px",
                    justifyContent: "center",
                  }}
                >
                  <Loader
                    type="Oval"
                    color={CustomStyle.colors.primary}
                    height={50}
                    width={50}
                  />
                </div>
              ) : (
                <Card className="card-tasks">
                  <Card.Header>
                    <Card.Title>All Promos</Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <div className="table-full-width" style={{ overflowX: "auto" }}>
                      <Table className="table-hover table-striped" style={{ minWidth: "600px" }}>
                        <thead>
                          <tr className="text-uppercase font-weight-bold small text-muted">
                            <th className="border-0 px-3">Promotion</th>
                            <th className="border-0">Description</th>
                            <th className="border-0">Warehouse</th>
                            <th className="border-0 text-right pr-4">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {results && results?.length > 0 ? (
                            results.map((item) => {
                              return (
                                <tr key={item._id} className="align-middle">
                                  <td className="px-3 py-3">
                                    <div className="d-flex align-items-center">
                                      <img
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          objectFit: "cover",
                                          boxShadow:
                                            "0 2px 4px rgba(0,0,0,0.1)",
                                        }}
                                        alt=""
                                        className="rounded mr-3 border"
                                        src={item?.media}
                                      />
                                      <div>
                                        <div className="font-weight-bold text-dark">
                                          {item.title}
                                        </div>
                                        <small className="text-muted">
                                          ID: {item._id?.substring(0, 8)}...
                                        </small>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="py-3">
                                    <div
                                      style={{
                                        maxWidth: "250px",
                                        fontSize: "0.9rem",
                                      }}
                                      className="text-secondary text-truncate-2"
                                    >
                                      {item.description}
                                    </div>
                                  </td>
                                  <td className="py-3">
                                    <span className="badge badge-light border px-2 py-1">
                                      {item.warehouseId?.name || "Global"}
                                    </span>
                                  </td>
                                  <td className="py-3 text-right pr-4">
                                    <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "4px" }}>
                                      <Link
                                        to={`${location.pathname}/${item._id}`}
                                        className="btn btn-outline-primary btn-sm btn-round mr-1 d-flex align-items-center"
                                        title="View Details"
                                        style={{
                                          color: CustomStyle.colors.primary,
                                          fontSize: "12px",
                                          textTransform: "uppercase",
                                          fontWeight: "700",
                                          textDecoration: "none",
                                          padding: "4px 10px",
                                        }}
                                      >
                                        <i
                                          className="nc-icon nc-zoom-split mr-1"
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                          }}
                                        ></i>{" "}
                                        View
                                      </Link>
                                      <Button
                                        className="btn btn-outline-info btn-sm btn-round mr-1 d-flex align-items-center"
                                        onClick={() => setActivePromo(item)}
                                        title="Edit Promo"
                                        style={{
                                          color: CustomStyle.colors.info,
                                          fontSize: "12px",
                                          textTransform: "uppercase",
                                          fontWeight: "700",
                                          textDecoration: "none",
                                          padding: "4px 10px",
                                        }}
                                      >
                                        <i
                                          className="nc-icon nc-settings-gear-64 mr-1"
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                          }}
                                        ></i>{" "}
                                        Edit
                                      </Button>
                                      <Button
                                        className="btn btn-outline-danger btn-sm btn-round d-flex align-items-center"
                                        onClick={() => {
                                          if (
                                            globalThis.confirm(
                                              "Are you sure you want to delete promo?",
                                            )
                                          ) {
                                            handleDeleteSubmit(item);
                                          }
                                        }}
                                        title="Delete Promo"
                                        style={{
                                          color: CustomStyle.colors.danger,
                                          fontSize: "12px",
                                          textTransform: "uppercase",
                                          fontWeight: "700",
                                          textDecoration: "none",
                                          padding: "4px 10px",
                                        }}
                                      >
                                        {loadingPromoDelete == item?._id ? (
                                          <Loader
                                            type="Oval"
                                            color={CustomStyle.colors.danger}
                                            height={12}
                                            width={12}
                                          />
                                        ) : (
                                          <>
                                            <i
                                              className="nc-icon nc-simple-remove mr-1"
                                              style={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                              }}
                                            ></i>{" "}
                                            Delete
                                          </>
                                        )}
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                colSpan="4"
                                style={{
                                  textAlign: "center",
                                  color: CustomStyle.colors.danger,
                                }}
                              >
                                <small>No promo found</small>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Card.Body>
                  <Card.Footer>
                    {promos?.total ? (
                      <ReactPaginate
                        previousLabel={<i className="nc-icon nc-stre-left"></i>}
                        nextLabel={<i className="nc-icon nc-stre-right"></i>}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={promos?.totalPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                      />
                    ) : null}
                  </Card.Footer>
                </Card>
              )}
            </Col>
          )}
          <Col md="4">
            <Card className="card-tasks">
              <Card.Header>
                <Card.Title as={Col}>
                  <Row>
                    <Col md="6">
                      <h5>All Warehouses</h5>
                    </Col>
                    <Col md="6">
                      <Button
                        className="btn-fill form-control"
                        type="submit"
                        variant="primary"
                        style={{
                          background: CustomStyle.colors.primary,
                          borderColor: CustomStyle.colors.primary,
                        }}
                        onClick={() => setIsOpen(true)}
                      >
                        Add Promo
                      </Button>
                    </Col>
                  </Row>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <div className="table-full-width">
                  <Table>
                    <tbody>
                      {processedWarehouses?.length > 0 ? (
                        processedWarehouses?.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                justifyContent: "space-between",
                                display: "flex",
                              }}
                            >
                              <div
                                onClick={() => fetchWarehousePromos(item._id)}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  flex: 1,
                                }}
                              >
                                <b>{item?.name}</b>
                              </div>
                              <input
                                // checked={
                                //   selectedWarehouse.includes(item?._id)
                                //     ? true
                                //     : false
                                // }
                                type="checkbox"
                                onChange={() => handleCheckbox(item)}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            style={{
                              textAlign: "center",
                              color: CustomStyle.colors.danger,
                            }}
                          >
                            <small>No warehouse found</small>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {selectedWarehouse.length > 0 && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          style={customStyles}
          contentLabel="Add Promo Modal"
        >
          <div className="modal-header border-0 pb-0 justify-content-between">
            <h4
              className="modal-title font-weight-bold"
              style={{ color: CustomStyle.colors.primary }}
            >
              Create New Promo
            </h4>
            <button
              type="button"
              className="close"
              onClick={() => setIsOpen(false)}
            >
              &times;
            </button>
          </div>
          <Form
            noValidate
            validated={validated}
            onSubmit={(e) => {
              e.preventDefault();
              onFormSubmit(e);
            }}
            className="p-3"
          >
            <Row>
              <Col md="8">
                <Form.Group controlId="promoTitle">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Promo Title
                  </Form.Label>
                  <Form.Control
                    placeholder="e.g. Summer Mega Sale"
                    type="text"
                    required
                    ref={titleInput}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group controlId="offerAmount">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Offer Amount
                  </Form.Label>
                  <Form.Control
                    placeholder="0"
                    type="number"
                    required
                    ref={offerInput}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group controlId="offerType">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Offer Type
                  </Form.Label>
                  <Form.Control
                    as="select"
                    required
                    ref={offerTypeInput}
                    value={offerType}
                    onChange={(e) => setOfferType(e.target.value)}
                  >
                    <option value="">Select Offer Type</option>
                    <option value="flat_amount">Flat Amount (₦)</option>
                    <option value="percent">Percentage (%)</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="fundingSource">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Funding Source
                  </Form.Label>
                  <Form.Control
                    as="select"
                    value={fundingSource}
                    required
                    onChange={(e) => setFundingSource(e.target.value)}
                  >
                    <option value="">Select Source</option>
                    <option value="justrite_funded">Justrite Funded</option>
                    <option value="vendor_funded">Vendor Funded</option>
                    <option value="co_funded">Co-Funded</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group controlId="promoType">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Promo Type
                  </Form.Label>
                  <Form.Control
                    as="select"
                    required
                    value={promoType}
                    onChange={(e) => setPromoType(e.target.value)}
                  >
                    <option value="">Select Promo Type</option>
                    <option value="discount">Discount</option>
                    <option value="cashback">Cashback</option>
                    <option value="free_item">Free Item</option>
                    <option value="bundle">Bundle</option>
                    <option value="voucher_coupon">Voucher/Coupon</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="promoStatus">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Status
                  </Form.Label>
                  <Form.Control
                    as="select"
                    required
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    <option value="live">Live</option>
                    <option value="draft">Draft</option>
                    <option value="approved">Approved</option>
                    <option value="paused">Paused</option>
                    <option value="expired">Expired</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group controlId="startDate">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Start Date
                  </Form.Label>
                  <Form.Control
                    type="datetime-local"
                    required
                    onChange={(e) => setStartDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="endDate">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    End Date
                  </Form.Label>
                  <Form.Control
                    type="datetime-local"
                    required
                    onChange={(e) => setEndDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group controlId="targetWarehouses">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Target Warehouses
                  </Form.Label>
                  <Select
                    isMulti
                    placeholder="Select warehouses..."
                    options={processedWarehouses.map((wh) => ({
                      value: wh._id,
                      label: wh.name,
                    }))}
                    onChange={(selected) =>
                      setSelectedWarehouse(
                        selected ? selected.map((s) => s.value) : [],
                      )
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group controlId="paymentOptions">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Payment Options
                  </Form.Label>
                  <Select
                    isMulti
                    placeholder="Select allowed payment methods..."
                    options={[
                      { value: "flutterwave", label: "Flutterwave" },
                      { value: "monnify", label: "Monnify" },
                      { value: "paystack", label: "Paystack" },
                      { value: "stanbic_bnpl", label: "Stanbic BNPL" },
                      { value: "squad", label: "Squad" },
                      { value: "wallet", label: "Wallet" },
                      { value: "wema_bnpl", label: "Wema BNPL" },
                    ]}
                    onChange={(selected) =>
                      setPaymentOptions(
                        selected ? selected.map((s) => s.value) : [],
                      )
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group controlId="productCategories">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Product Categories
                  </Form.Label>
                  <Select
                    isMulti
                    placeholder="Select categories..."
                    options={availableCategories}
                    value={selectedCategories}
                    onChange={(selected) =>
                      setSelectedCategories(selected || [])
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group controlId="promoDescription">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="3"
                    placeholder="Briefly describe the promotion..."
                    required
                    ref={descriptionInput}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md={imagePreview ? "8" : "12"}>
                <Form.Group controlId="promoBanner">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Promo Banner Image
                  </Form.Label>
                  <div className="custom-file">
                    <Form.File
                      className="custom-file-input"
                      id="customFile"
                      required
                      ref={mediaInput}
                      onChange={(e) => handleImageChange(e, "add")}
                      accept="image/*"
                    />
                    <label className="custom-file-label" htmlFor="customFile">
                      {mediaInput.current?.files?.[0]?.name ||
                        "Choose image..."}
                    </label>
                  </div>
                </Form.Group>
              </Col>
              {imagePreview && (
                <Col md="4" className="text-center">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100px",
                      borderRadius: "8px",
                      border: `2px solid ${CustomStyle.colors.hash}`,
                    }}
                  />
                </Col>
              )}
            </Row>

            <div className="mt-4">
              <Button
                className="btn-fill w-100"
                variant="primary"
                type="submit"
                disabled={submitLoading}
                style={{
                  background: CustomStyle.colors.primary,
                  borderColor: CustomStyle.colors.primary,
                  height: "50px",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                {submitLoading ? (
                  <Loader
                    type="Oval"
                    color={CustomStyle.colors.white}
                    height={20}
                    width={20}
                  />
                ) : (
                  "Create Promotion"
                )}
              </Button>
            </div>
          </Form>
        </Modal>
      )}
      {activePromo && activePromo?._id && (
        <Modal
          isOpen={true}
          onRequestClose={() => setActivePromo(null)}
          style={customStyles}
          contentLabel="Edit Promo Modal"
        >
          <div className="modal-header border-0 pb-0 justify-content-between">
            <h4
              className="modal-title font-weight-bold"
              style={{ color: CustomStyle.colors.primary }}
            >
              Edit Promotion
            </h4>
            <button
              type="button"
              className="close"
              onClick={() => setActivePromo(null)}
            >
              &times;
            </button>
          </div>
          <Form
            noValidate
            validated={formValidated}
            onSubmit={(e) => {
              e.preventDefault();
              handleUpdateSubmit(e);
            }}
            className="p-3"
          >
            <Row>
              <Col md="8">
                <Form.Group controlId="editPromoTitle">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Promo Title
                  </Form.Label>
                  <Form.Control
                    placeholder="Title"
                    type="text"
                    required
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group controlId="editOfferAmount">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Offer Amount
                  </Form.Label>
                  <Form.Control
                    placeholder="Offer"
                    type="number"
                    required
                    value={offer}
                    onChange={(e) => setOffer(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group controlId="editOfferType">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Offer Type
                  </Form.Label>
                  <Form.Control
                    as="select"
                    required
                    value={offerType}
                    onChange={(e) => setOfferType(e.target.value)}
                  >
                    <option value="flat_amount">Flat Amount (₦)</option>
                    <option value="percent">Percentage (%)</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="editFundingSource">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Funding Source
                  </Form.Label>
                  <Form.Control
                    as="select"
                    required
                    value={fundingSource}
                    onChange={(e) => setFundingSource(e.target.value)}
                  >
                    <option value="justrite_funded">Justrite Funded</option>
                    <option value="vendor_funded">Vendor Funded</option>
                    <option value="co_funded">Co-funded</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group controlId="editPromoType">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Promo Type
                  </Form.Label>
                  <Form.Control
                    as="select"
                    required
                    value={promoType}
                    onChange={(e) => setPromoType(e.target.value)}
                  >
                    <option value="discount">Discount</option>
                    <option value="cashback">Cashback</option>
                    <option value="free_item">Free Item</option>
                    <option value="bundle">Bundle</option>
                    <option value="voucher_coupon">Voucher/Coupon</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="editPromoStatus">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Status
                  </Form.Label>
                  <Form.Control
                    as="select"
                    required
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="live">Live</option>
                    <option value="draft">Draft</option>
                    <option value="approved">Approved</option>
                    <option value="paused">Paused</option>
                    <option value="expired">Expired</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group controlId="editStartDate">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Start Date
                  </Form.Label>
                  <Form.Control
                    type="datetime-local"
                    required
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="editEndDate">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    End Date
                  </Form.Label>
                  <Form.Control
                    type="datetime-local"
                    required
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group controlId="editTargetWarehouses">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Target Warehouses
                  </Form.Label>
                  <div
                    className="p-2 border rounded"
                    style={{
                      maxHeight: "150px",
                      overflowY: "auto",
                      background: "#f8f9fa",
                    }}
                  >
                    {processedWarehouses.map((wh) => (
                      <Form.Check
                        key={wh._id}
                        type="checkbox"
                        label={wh.name}
                        checked={selectedWarehouse.includes(wh._id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedWarehouse([
                              ...selectedWarehouse,
                              wh._id,
                            ]);
                          } else {
                            setSelectedWarehouse(
                              selectedWarehouse.filter((id) => id !== wh._id),
                            );
                          }
                        }}
                        className="mb-1"
                      />
                    ))}
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group controlId="editPaymentOptions">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Payment Options
                  </Form.Label>
                  <Select
                    isMulti
                    placeholder="Select payment options..."
                    options={[
                      { value: "flutterwave", label: "Flutterwave" },
                      { value: "monnify", label: "Monnify" },
                      { value: "paystack", label: "Paystack" },
                      { value: "stanbic_bnpl", label: "Stanbic BNPL" },
                      { value: "squad", label: "Squad" },
                      { value: "wallet", label: "Wallet" },
                      { value: "wema_bnpl", label: "Wema BNPL" },
                    ]}
                    value={[
                      { value: "flutterwave", label: "Flutterwave" },
                      { value: "monnify", label: "Monnify" },
                      { value: "paystack", label: "Paystack" },
                      { value: "stanbic_bnpl", label: "Stanbic BNPL" },
                      { value: "squad", label: "Squad" },
                      { value: "wallet", label: "Wallet" },
                      { value: "wema_bnpl", label: "Wema BNPL" },
                    ].filter((opt) => paymentOptions.includes(opt.value))}
                    onChange={(selected) =>
                      setPaymentOptions(
                        selected ? selected.map((s) => s.value) : [],
                      )
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group controlId="editProductCategories">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Product Categories
                  </Form.Label>
                  <Select
                    isMulti
                    placeholder="Select categories..."
                    options={availableCategories}
                    value={selectedCategories}
                    onChange={(selected) =>
                      setSelectedCategories(selected || [])
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group controlId="editPromoDescription">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="3"
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    placeholder="Promotion description..."
                    required
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md={editImagePreview || activePromo?.media ? "8" : "12"}>
                <Form.Group controlId="editBanner">
                  <Form.Label className="text-uppercase font-weight-bold small">
                    Banner Image
                  </Form.Label>
                  <div className="custom-file">
                    <Form.File
                      className="custom-file-input"
                      id="editFile"
                      ref={editMediaInput}
                      onChange={(e) => handleImageChange(e, "edit")}
                      accept="image/*"
                    />
                    <label className="custom-file-label" htmlFor="editFile">
                      {editMediaInput.current?.files?.[0]?.name ||
                        "Change image..."}
                    </label>
                  </div>
                </Form.Group>
              </Col>
              {(editImagePreview || activePromo?.media) && (
                <Col md="4" className="text-center">
                  <img
                    src={editImagePreview || activePromo?.media}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100px",
                      borderRadius: "8px",
                      border: `2px solid ${CustomStyle.colors.hash}`,
                    }}
                  />
                </Col>
              )}
            </Row>

            <div className="mt-4">
              <Button
                className="btn-fill w-100"
                variant="info"
                type="submit"
                disabled={editLoading}
                style={{
                  background: CustomStyle.colors.info,
                  borderColor: CustomStyle.colors.info,
                  height: "50px",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                {editLoading ? (
                  <Loader
                    type="Oval"
                    color={CustomStyle.colors.white}
                    height={20}
                    width={20}
                  />
                ) : (
                  "Update Promotion"
                )}
              </Button>
            </div>
          </Form>
        </Modal>
      )}
    </>
  );
}

export default Promos;
